import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class SeeInvoicesService {

  constructor(
    private http: HttpClient,
    ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

  obtenerFacturas(proveedor, fechaInicio, fechaFin, sociedad): Observable<any> {
    const usuario = proveedor;
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('fechai', fechaInicio)
      .set('fechaf', fechaFin)
      .set('sociedad', sociedad)
      .set('todas', 'X')
        };
    // tslint:disable-next-line:max-line-length
  //  return this.http.get('http://192.168.19.137:8080/degasa_api/estado-cta-prov/obtener-facturas-pagos/0000100351?fechai=2017-01-01&fechaf=2018-05-23&sociedad=1000&todas=X');
  return this.http.get(this.basePath + 'estado-cta-prov/obtener-facturas-pagos/' + usuario, options);
}

  solicitarComplemento(json): Observable<any> {
    const params = json;
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'complementos/solicitar-complemento', params, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/see-invoices/see-invoices.service.ts